import styled from 'styled-components';
import { boxStyle } from 'lib/styles/index';
import palette from 'lib/styles/palette';
import { useDispatch } from 'react-redux';
import { changeSensorData } from 'modules/serviceSlice';
import { useEffect } from 'react';

const SensorBoxRow = ({ sensor }) => {
  const { id, name, it, ih } = sensor;
  const dispatch = useDispatch();
  return (
    <SensorBoxRowBlock
      onClick={() => {
        dispatch(changeSensorData({ key: 'id', value: id }));
        dispatch(changeSensorData({ key: 'name', value: name }));
        dispatch(changeSensorData({ key: 'currentTemp', value: it }));
        dispatch(changeSensorData({ key: 'currentHumid', value: ih }));
      }}
    >
      <div className="ellipsis sensor-box-row-name" title={`${name}`}>
        {name}
      </div>
      <div className="it-ih-box">
        <div className="it-ih-box-item">{it === null ? `- ˚C` : `${it}˚C`}</div>
        <div className="it-ih-box-item">{ih === null ? `- %` : `${ih}%`}</div>
      </div>
    </SensorBoxRowBlock>
  );
};

const SensorBoxRowBlock = styled.div`
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: space-between;
  cursor: pointer;

  .sensor-box-row-name {
    width: 40%;
  }

  .it-ih-box {
    width: 55%;
    display: flex;
    justify-content: center;

    .it-ih-box-item {
      width: 100%;
      text-align: end;
    }
  }
`;

const SensorBox = ({ sensorData }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      changeSensorData({ key: 'id', value: sensorData?.sensorList[0]?.id }),
    );
    dispatch(
      changeSensorData({ key: 'name', value: sensorData?.sensorList[0]?.name }),
    );
    dispatch(
      changeSensorData({
        key: 'currentTemp',
        value: sensorData?.sensorList[0]?.it,
      }),
    );
    dispatch(
      changeSensorData({
        key: 'currentHumid',
        value: sensorData?.sensorList[0]?.ih,
      }),
    );
  }, [dispatch, sensorData?.sensorList]);

  return (
    <SensorBoxBlock>
      <div className="sensor-box-header">
        <div style={{ width: '40%' }}>그룹 평균</div>
        <div style={{ width: '55%', display: 'flex' }}>
          <div style={{ width: '100%', textAlign: 'end' }}>
            {sensorData?.avgit === 0 ? `- ˚C` : `${sensorData?.avgit}˚C`}
          </div>
          <div style={{ width: '100%', textAlign: 'end' }}>
            {sensorData?.avgit === 0 ? `- %` : `${sensorData?.avgih}%`}
          </div>
        </div>
      </div>
      {sensorData?.sensorList?.map(sensor => (
        <SensorBoxRow key={sensor.id} sensor={sensor} />
      ))}
    </SensorBoxBlock>
  );
};

export default SensorBox;

const SensorBoxBlock = styled.div`
  ${boxStyle}
  width: 200px;
  height: 100%;
  padding: 0.8em;
  display: flex;
  flex-direction: column;
  font-size: 12px;
  font-weight: 500;

  .sensor-box-header {
    width: 100%;
    margin-bottom: 0.5rem;
    display: flex;
    justify-content: space-between;
    color: ${palette.theme[3]};
  }
`;
